import { render, staticRenderFns } from "./head.vue?vue&type=template&id=790add9b&"
import script from "./head.vue?vue&type=script&lang=js&"
export * from "./head.vue?vue&type=script&lang=js&"
import style0 from "./head.vue?vue&type=style&index=0&id=790add9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseOrnamentBg: require('/opt/yamal.ru/src/components/base/ornament-bg.vue').default,RzIconArrowThin: require('/opt/yamal.ru/node_modules/razlet-ui/src/icons/icon-arrow-thin/index.vue').default,ScheduleFilter: require('/opt/yamal.ru/src/components/schedule/filter/index.vue').default,RzDottedLoader: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/dotted-loader/index.vue').default,RzContainer: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/container/index.vue').default})
